import React, { useState, useEffect, Suspense, lazy } from 'react'
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom'
import { initSupabaseClient, supabase } from '../database/supabaseclient.js'
import { AppProvider } from './contexts/AppContext.jsx'

// Lazy load components
const Layout = lazy(() => import('./components/Layout.jsx'))
const LoginPage = lazy(() => import('./pages/authpage.jsx'))
const Dashboard = lazy(() => import('./pages/Dashboard.jsx'))

// Initialize Supabase
initSupabaseClient()

function App() {
    console.log('App component is running!')
    const [session, setSession] = useState(null)
    const [loading, setLoading] = useState(true)

    useEffect(() => {
        console.log('App.jsx: useEffect triggered')
        // Get initial session
        const getInitialSession = async () => {
            console.log('App.jsx: Getting initial session...')
            const { data: { session } } = await supabase.auth.getSession()
            console.log('App.jsx: Session found:', session?.user?.email)
            setSession(session)
            setLoading(false)
        }

        getInitialSession()

        // Listen for auth changes
        const { data: { subscription } } = supabase.auth.onAuthStateChange((_event, session) => {
            setSession(session)
            setLoading(false)
        })

        return () => subscription.unsubscribe()
    }, [])

    if (loading) {
        return (
            <div className="min-h-screen flex items-center justify-center bg-gray-50">
                <div className="text-center">
                    <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500 mx-auto mb-4"></div>
                    <div className="text-gray-600">Loading FastParts...</div>
                </div>
            </div>
        )
    }

    return (
        <Router>
            <AppProvider>
                <Suspense fallback={
                    <div className="min-h-screen flex items-center justify-center bg-gray-50">
                        <div className="text-center">
                            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500 mx-auto mb-4"></div>
                            <div className="text-gray-600">Loading...</div>
                        </div>
                    </div>
                }>
                    <Routes>
                        <Route path="/login" element={!session ? <LoginPage /> : <Navigate to="/" replace />} />
                        <Route path="/" element={session ? <Layout /> : <Navigate to="/login" replace />}>
                            <Route index element={<Dashboard />} />
                            <Route path="*" element={<Navigate to="/" replace />} />
                        </Route>
                    </Routes>
                </Suspense>
            </AppProvider>
        </Router>
    )
}

export default App 